import { db } from 'technical/db';

export const utilsDbService = {
  async isDbEmpty() {
    const drawConfigNumber = await db.segmentDrawConfigs.count();
    const ringNumber = await db.rings.count();
    const segmentNumber = await db.segments.count();

    return drawConfigNumber === 0 && ringNumber === 0 && segmentNumber === 0;
  },
};
